export const formatMileage = (value) =>
  `${Number(value).toLocaleString()} Miles`;

export const formatPrice = (value) => `£${Number(value).toLocaleString()}`;

export const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1);
